import Header from '../components/Header';
import HeroSlider from '../components/HeroSlider';
import Features from '../components/Features';
import Footer from '../components/Footer';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export default function Home() {
  const [shrink, setShrink] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    let lastScroll = window.scrollY;
    const onScroll = () => {
      if (window.scrollY > 50 && window.scrollY > lastScroll) {
        setShrink(true);
      } else if (window.scrollY < lastScroll) {
        setShrink(false);
      }
      lastScroll = window.scrollY;
    };
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Scroll to features if navigated with state
  useEffect(() => {
    if (location.state?.scrollTo === 'features') {
      const el = document.getElementById('features');
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: 'smooth' });
        }, 100); // wait for render
      }
      // Clear state so it doesn't scroll again
      navigate('/', { replace: true, state: {} });
    }
  }, [location, navigate]);

  return (
    <div className="q2o-bg min-h-screen">
      <Header shrink={shrink} />
      <HeroSlider shrink={shrink} />
      <Features shrink={shrink} />
     
      <Footer />
    </div>
  );
} 